import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { UploadCloud } from "lucide-react";
import { toast } from "sonner";

export default function ImageUpload({ value, onChange, testid = "image-upload" }) {
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("Immagine caricata");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3">
        <label
          className="av-pill av-pill-ghost text-xs cursor-pointer"
          data-testid={`${testid}-label`}
        >
          <UploadCloud size={14} />
          {busy ? "Carico…" : "Carica immagine"}
          <input
            type="file"
            accept="image/jpeg,image/png,image/webp"
            className="hidden"
            onChange={handle}
            data-testid={testid}
          />
        </label>
        {value && (
          <img src={value} alt="" className="w-10 h-10 rounded object-cover border av-hairline" />
        )}
      </div>
      <input
        className="av-input mt-2"
        placeholder="…oppure incolla un URL"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
